module.exports = __webpack_public_path__ + "static/img/banner6.e1db42d.jpeg";


//////////////////
// WEBPACK FOOTER
// ./static/image/banner6.jpeg
// module id = O3G1
// module chunks = 14